export default {"src":"/_next/static/media/ic_plus_button.425474f2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};